import {createContext} from 'react';

export const SimpleStorageContext = createContext();
